"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import Breadcrumbs from "@/components/common/BreadCrumb";
import { DEFAULT_PAGE, NEXT_PAGE_NUMBER, } from "@/constants/appConstant";
import { getPostsByTopicUrlName } from "@/app/api/post/postAPI";
import { usePathname } from "next/navigation";
import Paging from "@/components/common/paging/Paging";
import { Skeleton } from 'primereact/skeleton';
import OptimizedImage from '@/components/common/optimizedImage/OptimizedImage';
import PageHeader from "@/components/common/page-header";

export default function Home() {
    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
    const [hasNext, setHasNext] = useState(true);
    const [totalElements, setTotalElements] = useState(0);
    const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);
    const pathname = usePathname();
    const urlName = pathname ? `/${pathname.split("/")[1]}` : '';

    useEffect(() => {
        if (!urlName) return;
        const fetchPosts = async () => {
            const response = await getPostsByTopicUrlName(urlName, currentPage);
            if (response?.data?.data) {
                if (currentPage === DEFAULT_PAGE) {
                    setPosts(response.data.data.content);
                } else {
                    setPosts(prevPosts => [...prevPosts, ...response.data.data.content]);
                }
                setHasNext(response.data.data.hasNext);
                setTotalElements(response.data.data.totalElements);
            }
        };
        fetchPosts();
    }, [urlName, currentPage]);

    const handleLoadMore = async () => {
        await setCurrentPage(currentPage + NEXT_PAGE_NUMBER);
    };

    const paths = [{ name: "TRANG CHỦ", url: "/" }, { name: "DỊCH VỤ CHÍNH" }];

    return (
        <>
            <PageHeader title="Dịch vụ chính" />

            <div className="container-fluid" style={{ marginTop: "20px" }}>
                <Breadcrumbs paths={paths} />
            </div>
            <hr className="w-full border-t-2 border-gray-600" />

            <div className="mobile-sidebar-trigger">
                <button onClick={() => setIsSidebarMobileOpen(!isSidebarMobileOpen)}>
                    Danh mục dịch vụ ☰
                </button>
            </div>

            {isSidebarMobileOpen && (
                <div className="mobile-sidebar-menu">
                    <ul>
                        {posts?.map((post) => (
                            <li key={post.id}>
                                <Link href={post.urlName}>{post.name}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {posts?.length === 0 ? (
                <div className="container-fluid block-content mb-7">
                    <div className="row main-grid" style={{ marginTop: "-20px" }}>
                        <div className="col-sm-3"><Skeleton width="260px" height="400px"></Skeleton></div>
                        <div className="col-sm-9">
                            <div className="row services">
                                {[1, 2, 3].map((i) => (
                                    <div key={i} className="service-item col-xs-12 col-sm-4 col-md-4 col-lg-4 mb-7">
                                        <Skeleton width="360px" height="270px"></Skeleton>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                // --- PHẦN HIỂN THỊ DỮ LIỆU ---
                <div className="container-fluid block-content mb-7">
                    <div className="row main-grid" style={{ marginTop: "-40px" }}>
                        {/* SIDEBAR */}
                        <div className="col-sm-3 wow slideInUp" data-wow-delay="0.3s">
                            <div className="sidebar-container">
                                <ul className="styled">
                                    {posts?.map((post, index) => {
                                        const safeKey = post?.id || post?.urlName || `${index}-sidebar`;
                                        return (
                                            <li key={safeKey}>
                                                <Link href={post.urlName}>{post?.name}</Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* DANH SÁCH BÀI VIẾT */}
                        <div className="col-sm-9">
                            <div className="row services">
                                {posts && posts?.map((post, index) => {
                                    const safeKey = post?.id || post?.urlName || `${index}-grid`;
                                    return (
                                        <div key={safeKey}
                                            className="service-item col-xs-12 col-sm-4 col-md-4 col-lg-4 wow zoomIn mb-0"
                                            data-wow-delay="0.3s"
                                        >
                                            <div className="img-service">
                                                <Link href={post.urlName}>
                                                    <OptimizedImage
                                                        src={post.titleImage} 
                                                        alt={post.name}
                                                        width={360}
                                                        height={270}
                                                        className="full-width"
                                                        priority={index < 6} 
                                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                                    />
                                                </Link>
                                            </div>

                                            <Link className="no-underline" href={post.urlName}>
                                                <h4 className="name-post">{post.name}</h4>
                                            </Link>
                                            <p className="description-post">{post.description}</p>

                                            <div className="text-center">
                                                <Link
                                                    className="btn btn-brand m-3 align-items-center"
                                                    href={post.urlName}
                                                >
                                                    Chi tiết
                                                </Link>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            <Paging
                                onLoadMore={handleLoadMore}
                                totalElements={totalElements}
                                hasNext={hasNext}
                                data={posts}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}